<template>
  <div>
    <el-dialog :title="select ? '查看' : isupload ? '编辑' : '新增'" :visible.sync="visible_v" width="1100px" @close="() => {
        $emit('cancel')
      }
      ">
      <el-tabs v-if="!isupload && !select" v-model="activeName">
        <el-tab-pane label="新增在职职工" name="zz">
          <Form ref="addEmployess" :label-width="120" :model="formCustom" :rules="ruleValidate" inline>
            <Form-item label="员工编号：">
              <Input v-model="formCustom.zgbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="姓：" prop="x">
              <Input v-model="formCustom.x" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="名：" prop="m">
              <Input v-model="formCustom.m" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="姓名：" prop="xm">
              <Input v-model="formCustom.xm" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="国籍：" prop="gj">
              <el-select v-model="formCustom.gj" :disabled="select" filterable>
                <el-option v-for="item in countryArr" :key="item.id" :label="item.Chinese" :value="item.Chinese">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="出生地点：">
              <Input v-model="formCustom.csdd" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="性别：" prop="xb">
              <Input v-model="formCustom.xb" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="出生年月日：" prop="csnyr">
              <DatePicker :disabled="select" :value="formCustom.csnyr" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changecsnyr"/>
            </Form-item>
            <Form-item label="类型：" prop="yglx">
              <Select v-model="formCustom.yglx" :disabled="select" style="width: 200px;">
                <Option value="员工">员工</Option>
              </Select>
            </Form-item>
            <Form-item label="学院：" prop="xy">
              <Input v-model="formCustom.xy" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="部门：" prop="bm">
              <Input v-model="formCustom.bm" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="岗位名称：" prop="gwmc">
              <Input v-model="formCustom.gwmc" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="合同开始时间：">
              <DatePicker :disabled="select" :value="formCustom.htkssj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehtkssj"/>
            </Form-item>
            <Form-item label="合同结束时间：">
              <DatePicker :disabled="select" :value="formCustom.htjssj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehtjssj"/>
            </Form-item>
            <Form-item label="薪资：">
              <Input v-model="formCustom.xz" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="护照号码：" prop="hzhm">
              <Input v-model="formCustom.hzhm" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="护照签发日期：" prop="hzqfrq">
              <DatePicker :disabled="select" :value="formCustom.hzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehzqfrq"/>
            </Form-item>
            <Form-item label="护照到期日期：" prop="hzdqrq">
              <DatePicker :disabled="select" :value="formCustom.hzdqrq" style="width: 200px;" type="date"
                          @on-change="changehzdqrq"/>
            </Form-item>
            <p class="tips">
              当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
            <Form-item label="工作许可证编号：">
              <Input v-model="formCustom.gzxkzbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="工作许可证发证日期：">
              <DatePicker :disabled="select" :value="formCustom.gzxkzfzrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changegzxkzfzrq"/>
            </Form-item>
            <Form-item label="工作许可证到期日期：">
              <DatePicker :disabled="select" :value="formCustom.gzfkzdqrq" style="width: 200px;" type="date"
                          @on-change="changegzfkzdqrq"/>
            </Form-item>
            <p class="tips">
              当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
            <Form-item label="居留许可证编号：">
              <Input v-model="formCustom.jlxkzbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="居留许可证签发日期：">
              <DatePicker :disabled="select" :value="formCustom.jlxkzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changejlxkzqfrq"/>
            </Form-item>
            <Form-item label="居留许可证到期日期：">
              <DatePicker :disabled="select" :value="formCustom.jlxkzdqrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changejlxkzdqrq"/>
            </Form-item>
            <Form-item label="保单到期时间：">
              <DatePicker :disabled="select" :value="formCustom.bddqsj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changebddqsj"/>
            </Form-item>
            <Form-item label="HR负责人：" prop="hrfzr">
              <Input v-model="formCustom.hrfzr" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="工作证类别：" prop="gzzlb">
              <el-select v-model="formCustom.gzzlb" :disabled="select">
                <el-option value="A">
                </el-option>
                <el-option value="B">
                </el-option>
                <el-option value="A-PR">
                </el-option>
                <el-option value="B-PR">
                </el-option>
                <el-option value="C">
                </el-option>
                <el-option value="无WPC">
                </el-option>
                <el-option value="WPC过期">
                </el-option>
                <el-option value="无WPC-PR">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="外专局账户：">
              <el-select v-model="formCustom.wzjzh" :disabled="select">
                <el-option value="UNNC">
                </el-option>
                <el-option value="CIIC">
                </el-option>
                <el-option value="/">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="手机号码：">
              <Input v-model="formCustom.sjhm" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="全职-兼职：">
              <el-select v-model="formCustom.gzxz" :disabled="select">
                <el-option value="全职">
                </el-option>
                <el-option value="兼职">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="境内/境外：">
              <el-select v-model="formCustom.gjlx" :disabled="select">
                <el-option value="境内">
                </el-option>
                <el-option value="境外">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="岗位类别：">
              <el-select v-model="formCustom.gwlb" :disabled="select">
                <el-option value="教学">
                </el-option>
                <el-option value="科研">
                </el-option>
                <el-option value="管理">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="专业科目：">
              <el-select v-model="formCustom.zykm" :disabled="select">
                <el-option label="哲学" value="哲学">
                </el-option>
                <el-option value="经济学">
                </el-option>
                <el-option value="法学">
                </el-option>
                <el-option value="教育学">
                </el-option>
                <el-option value="文学">
                </el-option>
                <el-option value="理学">
                </el-option>
                <el-option value="工学">
                </el-option>
                <el-option value="农学">
                </el-option>
                <el-option value="管理学">
                </el-option>
                <el-option value="艺术学">
                </el-option>
                <el-option value="外国语言教育">
                </el-option>
                <el-option value="西班牙语">
                </el-option>
                <el-option value="英语">
                </el-option>
                <el-option value="法语">
                </el-option>
                <el-option value="德语">
                </el-option>
                <el-option value="俄语">
                </el-option>
                <el-option value="意大利语">
                </el-option>
                <el-option value="葡萄牙语">
                </el-option>
                <el-option value="日语">
                </el-option>
                <el-option value="韩语">
                </el-option>
                <el-option value="阿拉伯语">
                </el-option>
                <el-option value="其它">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="语言类/非语言类：">
              <el-select v-model="formCustom.yylfyyl" :disabled="select">
                <el-option value="语言类">
                </el-option>
                <el-option value="非语言类">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="针对语言类是否母语：">
              <el-select v-model="formCustom.zdyylsfmy" :disabled="select">
                <el-option value="是">
                </el-option>
                <el-option value="否">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="学科类/非学科类：">
              <el-select v-model="formCustom.xklfxkl" :disabled="select">
                <el-option value="学科类">
                </el-option>
                <el-option value="非学科类">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="最高学位：">
              <el-select v-model="formCustom.zgxw" :disabled="select">
                <el-option value="博士">
                </el-option>
                <el-option value="硕士">
                </el-option>
                <el-option value="学士">
                </el-option>
                <el-option value="高中">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="是否有有效职业资格证书：">
              <el-select v-model="formCustom.sfyyxzyzgzs" :disabled="select">
                <el-option value="是">
                </el-option>
                <el-option value="否">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="签证类别：">
              <el-select v-model="formCustom.qzlb" :disabled="select">
                <el-option value="Z">
                </el-option>
                <el-option value="R">
                </el-option>
                <el-option value="F">
                </el-option>
                <el-option value="M">
                </el-option>
                <el-option value="C">
                </el-option>
                <el-option value="D">
                </el-option>
                <el-option value="G">
                </el-option>
                <el-option value="J1">
                </el-option>
                <el-option value="J2">
                </el-option>
                <el-option value="L">
                </el-option>
                <el-option value="Q1">
                </el-option>
                <el-option value="Q2">
                </el-option>
                <el-option value="S1">
                </el-option>
                <el-option value="S2">
                </el-option>
                <el-option value="X1">
                </el-option>
                <el-option value="X3">
                </el-option>
                <el-option value="永久居留许可">
                </el-option>
                <el-option value="不适用">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="聘用合同类型：">
              <el-select v-model="formCustom.pyhtlx" :disabled="select">
                <el-option value="劳动">
                </el-option>
                <el-option value="劳务">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="宗教：">
              <el-select v-model="formCustom.zj" :disabled="select">
                <el-option value="未知">
                </el-option>
                <el-option value="无">
                </el-option>
                <el-option value="佛教">
                </el-option>
                <el-option value="基督教">
                </el-option>
                <el-option value="伊斯兰教">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="婚姻状况：">
              <el-select v-model="formCustom.hyzk" :disabled="select">
                <el-option value="未知">
                </el-option>
                <el-option value="未婚">
                </el-option>
                <el-option value="已婚">
                </el-option>
                <el-option value="离异">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="原单位类型：">
              <el-select v-model="formCustom.ydwlx" :disabled="select" allow-create filterable>
                <el-option value="高校">
                </el-option>
                <el-option value="中小学">
                </el-option>
                <el-option value="幼儿园">
                </el-option>
                <el-option value="培训机构">
                </el-option>
                <el-option value="无">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="工作年限：">
              <Input v-model="formCustom.gznx" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="离职日期：">
              <DatePicker :disabled="select" :value="formCustom.lzrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changelzrq"/>
            </Form-item>
            <Form-item label="在甬住址：">
              <Input v-model="formCustom.zydz" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="原单位名称：">
              <Input v-model="formCustom.ydwmc" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="毕业院校：">
              <Input v-model="formCustom.byyx" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="备注：">
              <Input v-model="formCustom.bz" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
          </Form>
          <Button :loading="addloading" style="margin-left: 500px;" type="primary" @click="add">
            确定
          </Button>
        </el-tab-pane>
        <el-tab-pane label="新增待入职职工" name="drz">
          <Form ref="addDEmployess" :label-width="120" :model="formCustom" :rules="ruleValidateD" inline>
            <Form-item label="员工编号：">
              <Input v-model="formCustom.zgbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="姓：" prop="x">
              <Input v-model="formCustom.x" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="名：" prop="m">
              <Input v-model="formCustom.m" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="姓名：" prop="xm">
              <Input v-model="formCustom.xm" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="国籍：" prop="gj">
              <el-select v-model="formCustom.gj" :disabled="select" filterable>
                <el-option v-for="item in countryArr" :key="item.id" :label="item.Chinese" :value="item.Chinese">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="出生地点：">
              <Input v-model="formCustom.csdd" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="性别：" prop="xb">
              <Input v-model="formCustom.xb" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="出生年月日：" prop="csnyr">
              <DatePicker :disabled="select" :value="formCustom.csnyr" format="yyyy-MM-dd" style="width: 200px;"
                          type="date"
                          @on-change="changecsnyr"/>
            </Form-item>
            <Form-item label="类型：" prop="yglx">
              <Select v-model="formCustom.yglx" :disabled="select" style="width: 200px;">
                <Option value="员工">员工</Option>
              </Select>
            </Form-item>
            <Form-item label="学院：" prop="xy">
              <Input v-model="formCustom.xy" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="部门：" prop="bm">
              <Input v-model="formCustom.bm" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="岗位名称：" prop="gwmc">
              <Input v-model="formCustom.gwmc" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="合同开始时间：">
              <DatePicker :disabled="select" :value="formCustom.htkssj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehtkssj"/>
            </Form-item>
            <Form-item label="合同结束时间：">
              <DatePicker :disabled="select" :value="formCustom.htjssj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehtjssj"/>
            </Form-item>
            <Form-item label="薪资：">
              <Input v-model="formCustom.xz" :disabled="select" clearable style="width: 200px"></Input>
            </Form-item>
            <Form-item label="护照号码：" prop="hzhm">
              <Input v-model="formCustom.hzhm" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="护照签发日期：" prop="hzqfrq">
              <DatePicker :disabled="select" :value="formCustom.hzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changehzqfrq"/>
            </Form-item>
            <Form-item label="护照到期日期：" prop="hzdqrq">
              <DatePicker :disabled="select" :value="formCustom.hzdqrq" style="width: 200px;" type="date"
                          @on-change="changehzdqrq"/>
            </Form-item>
            <p class="tips">
              当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
            <Form-item label="工作许可证编号：">
              <Input v-model="formCustom.gzxkzbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="工作许可证发证日期：">
              <DatePicker :disabled="select" :value="formCustom.gzxkzfzrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changegzxkzfzrq"/>
            </Form-item>
            <Form-item label="工作许可证到期日期：">
              <DatePicker :disabled="select" :value="formCustom.gzfkzdqrq" style="width: 200px;" type="date"
                          @on-change="changegzfkzdqrq"/>
            </Form-item>
            <p class="tips">
              当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
            <Form-item label="居留许可证编号：">
              <Input v-model="formCustom.jlxkzbh" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="居留许可证签发日期：">
              <DatePicker :disabled="select" :value="formCustom.jlxkzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changejlxkzqfrq"/>
            </Form-item>
            <Form-item label="居留许可证到期日期：">
              <DatePicker :disabled="select" :value="formCustom.jlxkzdqrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changejlxkzdqrq"/>
            </Form-item>
            <Form-item label="保单到期时间：">
              <DatePicker :disabled="select" :value="formCustom.bddqsj" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changebddqsj"/>
            </Form-item>
            <Form-item label="HR负责人：" prop="hrfzr">
              <Input v-model="formCustom.hrfzr" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="工作证类别：" prop="gzzlb">
              <el-select v-model="formCustom.gzzlb" :disabled="select">
                <el-option value="A">
                </el-option>
                <el-option value="B">
                </el-option>
                <el-option value="A-PR">
                </el-option>
                <el-option value="B-PR">
                </el-option>
                <el-option value="C">
                </el-option>
                <el-option value="无WPC">
                </el-option>
                <el-option value="WPC过期">
                </el-option>
                <el-option value="无WPC-PR">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="外专局账户：">
              <el-select v-model="formCustom.wzjzh" :disabled="select">
                <el-option value="UNNC">
                </el-option>
                <el-option value="CIIC">
                </el-option>
                <el-option value="/">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="手机号码：">
              <Input v-model="formCustom.sjhm" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="全职-兼职：">
              <el-select v-model="formCustom.gzxz" :disabled="select">
                <el-option value="全职">
                </el-option>
                <el-option value="兼职">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="境内/境外：">
              <el-select v-model="formCustom.gjlx" :disabled="select">
                <el-option value="境内">
                </el-option>
                <el-option value="境外">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="岗位类别：">
              <el-select v-model="formCustom.gwlb" :disabled="select">
                <el-option value="教学">
                </el-option>
                <el-option value="科研">
                </el-option>
                <el-option value="管理">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="专业科目：">
              <el-select v-model="formCustom.zykm" :disabled="select">
                <el-option label="哲学" value="哲学">
                </el-option>
                <el-option value="经济学">
                </el-option>
                <el-option value="法学">
                </el-option>
                <el-option value="教育学">
                </el-option>
                <el-option value="文学">
                </el-option>
                <el-option value="理学">
                </el-option>
                <el-option value="工学">
                </el-option>
                <el-option value="农学">
                </el-option>
                <el-option value="管理学">
                </el-option>
                <el-option value="艺术学">
                </el-option>
                <el-option value="外国语言教育">
                </el-option>
                <el-option value="西班牙语">
                </el-option>
                <el-option value="英语">
                </el-option>
                <el-option value="法语">
                </el-option>
                <el-option value="德语">
                </el-option>
                <el-option value="俄语">
                </el-option>
                <el-option value="意大利语">
                </el-option>
                <el-option value="葡萄牙语">
                </el-option>
                <el-option value="日语">
                </el-option>
                <el-option value="韩语">
                </el-option>
                <el-option value="阿拉伯语">
                </el-option>
                <el-option value="其它">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="语言类/非语言类：">
              <el-select v-model="formCustom.yylfyyl" :disabled="select">
                <el-option value="语言类">
                </el-option>
                <el-option value="非语言类">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="针对语言类是否母语：">
              <el-select v-model="formCustom.zdyylsfmy" :disabled="select">
                <el-option value="是">
                </el-option>
                <el-option value="否">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="学科类/非学科类：">
              <el-select v-model="formCustom.xklfxkl" :disabled="select">
                <el-option value="学科类">
                </el-option>
                <el-option value="非学科类">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="最高学位：">
              <el-select v-model="formCustom.zgxw" :disabled="select">
                <el-option value="博士">
                </el-option>
                <el-option value="硕士">
                </el-option>
                <el-option value="学士">
                </el-option>
                <el-option value="高中">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="是否有有效职业资格证书：">
              <el-select v-model="formCustom.sfyyxzyzgzs" :disabled="select">
                <el-option value="是">
                </el-option>
                <el-option value="否">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="签证类别：">
              <el-select v-model="formCustom.qzlb" :disabled="select">
                <el-option value="Z">
                </el-option>
                <el-option value="R">
                </el-option>
                <el-option value="F">
                </el-option>
                <el-option value="M">
                </el-option>
                <el-option value="C">
                </el-option>
                <el-option value="D">
                </el-option>
                <el-option value="G">
                </el-option>
                <el-option value="J1">
                </el-option>
                <el-option value="J2">
                </el-option>
                <el-option value="L">
                </el-option>
                <el-option value="Q1">
                </el-option>
                <el-option value="Q2">
                </el-option>
                <el-option value="S1">
                </el-option>
                <el-option value="S2">
                </el-option>
                <el-option value="X1">
                </el-option>
                <el-option value="X3">
                </el-option>
                <el-option value="永久居留许可">
                </el-option>
                <el-option value="不适用">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="聘用合同类型：">
              <el-select v-model="formCustom.pyhtlx" :disabled="select">
                <el-option value="劳动">
                </el-option>
                <el-option value="劳务">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="宗教：">
              <el-select v-model="formCustom.zj" :disabled="select">
                <el-option value="未知">
                </el-option>
                <el-option value="无">
                </el-option>
                <el-option value="佛教">
                </el-option>
                <el-option value="基督教">
                </el-option>
                <el-option value="伊斯兰教">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="婚姻状况：">
              <el-select v-model="formCustom.hyzk" :disabled="select">
                <el-option value="未知">
                </el-option>
                <el-option value="未婚">
                </el-option>
                <el-option value="已婚">
                </el-option>
                <el-option value="离异">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="原单位类型：">
              <el-select v-model="formCustom.ydwlx" :disabled="select" allow-create filterable>
                <el-option value="高校">
                </el-option>
                <el-option value="中小学">
                </el-option>
                <el-option value="幼儿园">
                </el-option>
                <el-option value="培训机构">
                </el-option>
                <el-option value="无">
                </el-option>
              </el-select>
            </Form-item>
            <Form-item label="工作年限：">
              <Input v-model="formCustom.gznx" :disabled="select" clearable
                     style="width: 200px"></Input>
            </Form-item>
            <Form-item label="离职日期：">
              <DatePicker :disabled="select" :value="formCustom.lzrq" format="yyyy-MM-dd" style="width: 200px;"
                          type="date" @on-change="changelzrq"/>
            </Form-item>
            <Form-item label="在甬住址：">
              <Input v-model="formCustom.zydz" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="原单位名称：">
              <Input v-model="formCustom.ydwmc" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="毕业院校：">
              <Input v-model="formCustom.byyx" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item label="备注：">
              <Input v-model="formCustom.bz" :disabled="select" clearable style="width: 400px"></Input>
            </Form-item>
            <Form-item>
              <Button :loading="addloading" style="margin-left:400px;" type="primary" @click="addD">
                确定
              </Button>
            </Form-item>
          </Form>
        </el-tab-pane>
      </el-tabs>
      <div v-if="isupload">
        <Form ref="putEmployess" :label-width="120" :model="formCustom" :rules="ruleValidate" inline>
          <Form-item label="员工编号：">
            <Input v-model="formCustom.zgbh" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="姓：" prop="x">
            <Input v-model="formCustom.x" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="名：" prop="m">
            <Input v-model="formCustom.m" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="姓名：" prop="xm">
            <Input v-model="formCustom.xm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="国籍：" prop="gj">
            <el-select v-model="formCustom.gj" :disabled="select" filterable>
              <el-option v-for="item in countryArr" :key="item.id" :label="item.Chinese" :value="item.Chinese">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="出生地点：">
            <Input v-model="formCustom.csdd" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="性别：" prop="xb">
            <Input v-model="formCustom.xb" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="出生年月日：" prop="csnyr">
            <DatePicker :disabled="select" :value="formCustom.csnyr" format="yyyy-MM-dd" style="width: 200px;"
                        type="date"
                        @on-change="changecsnyr"/>
          </Form-item>
          <Form-item label="类型：" prop="yglx">
            <Select v-model="formCustom.yglx" :disabled="select" style="width: 200px;">
              <Option value="员工">员工</Option>
            </Select>
          </Form-item>
          <Form-item label="学院：" prop="xy">
            <Input v-model="formCustom.xy" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="部门：" prop="bm">
            <Input v-model="formCustom.bm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="岗位名称：" prop="gwmc">
            <Input v-model="formCustom.gwmc" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="合同开始时间：">
            <DatePicker :disabled="select" :value="formCustom.htkssj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehtkssj"/>
          </Form-item>
          <Form-item label="合同结束时间：">
            <DatePicker :disabled="select" :value="formCustom.htjssj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehtjssj"/>
          </Form-item>
          <Form-item label="薪资：">
            <Input v-model="formCustom.xz" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="护照号码：" prop="hzhm">
            <Input v-model="formCustom.hzhm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="护照签发日期：" prop="hzqfrq">
            <DatePicker :disabled="select" :value="formCustom.hzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehzqfrq"/>
          </Form-item>
          <Form-item label="护照到期日期：" prop="hzdqrq">
            <DatePicker :disabled="select" :value="formCustom.hzdqrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehzdqrq"/>
          </Form-item>
          <p class="tips">
            当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
          <Form-item label="工作许可证编号：">
            <Input v-model="formCustom.gzxkzbh" :disabled="select" clearable
                   style="width: 200px"></Input>
          </Form-item>
          <Form-item label="工作许可证发证日期：">
            <DatePicker :disabled="select" :value="formCustom.gzxkzfzrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changegzxkzfzrq"/>
          </Form-item>
          <Form-item label="工作许可证到期日期：">
            <DatePicker :disabled="select" :value="formCustom.gzfkzdqrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changegzfkzdqrq"/>
          </Form-item>
          <p class="tips">
            当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
          <Form-item label="居留许可证编号：">
            <Input v-model="formCustom.jlxkzbh" :disabled="select" clearable
                   style="width: 200px"></Input>
          </Form-item>
          <Form-item label="居留许可证签发日期：">
            <DatePicker :disabled="select" :value="formCustom.jlxkzqfrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changejlxkzqfrq"/>
          </Form-item>
          <Form-item label="居留许可证到期日期：">
            <DatePicker :disabled="select" :value="formCustom.jlxkzdqrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changejlxkzdqrq"/>
          </Form-item>
          <Form-item label="保单到期时间：">
            <DatePicker :disabled="select" :value="formCustom.bddqsj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changebddqsj"/>
          </Form-item>
          <Form-item label="HR负责人：" prop="hrfzr">
            <Input v-model="formCustom.hrfzr" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="工作证类别：" prop="gzzlb">
            <el-select v-model="formCustom.gzzlb" :disabled="select">
              <el-option value="A">
              </el-option>
              <el-option value="B">
              </el-option>
              <el-option value="A-PR">
              </el-option>
              <el-option value="B-PR">
              </el-option>
              <el-option value="C">
              </el-option>
              <el-option value="无WPC">
              </el-option>
              <el-option value="WPC过期">
              </el-option>
              <el-option value="无WPC-PR">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="外专局账户：">
            <el-select v-model="formCustom.wzjzh" :disabled="select">
              <el-option value="UNNC">
              </el-option>
              <el-option value="CIIC">
              </el-option>
              <el-option value="/">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="手机号码：">
            <Input v-model="formCustom.sjhm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="全职-兼职：">
            <el-select v-model="formCustom.gzxz" :disabled="select">
              <el-option value="全职">
              </el-option>
              <el-option value="兼职">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="境内/境外：">
            <el-select v-model="formCustom.gjlx" :disabled="select">
              <el-option value="境内">
              </el-option>
              <el-option value="境外">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="岗位类别：">
            <el-select v-model="formCustom.gwlb" :disabled="select">
              <el-option value="教学">
              </el-option>
              <el-option value="科研">
              </el-option>
              <el-option value="管理">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="专业科目：">
            <el-select v-model="formCustom.zykm" :disabled="select">
              <el-option label="哲学" value="哲学">
              </el-option>
              <el-option value="经济学">
              </el-option>
              <el-option value="法学">
              </el-option>
              <el-option value="教育学">
              </el-option>
              <el-option value="文学">
              </el-option>
              <el-option value="理学">
              </el-option>
              <el-option value="工学">
              </el-option>
              <el-option value="农学">
              </el-option>
              <el-option value="管理学">
              </el-option>
              <el-option value="艺术学">
              </el-option>
              <el-option value="外国语言教育">
              </el-option>
              <el-option value="西班牙语">
              </el-option>
              <el-option value="英语">
              </el-option>
              <el-option value="法语">
              </el-option>
              <el-option value="德语">
              </el-option>
              <el-option value="俄语">
              </el-option>
              <el-option value="意大利语">
              </el-option>
              <el-option value="葡萄牙语">
              </el-option>
              <el-option value="日语">
              </el-option>
              <el-option value="韩语">
              </el-option>
              <el-option value="阿拉伯语">
              </el-option>
              <el-option value="其它">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="语言类/非语言类：">
            <el-select v-model="formCustom.yylfyyl" :disabled="select">
              <el-option value="语言类">
              </el-option>
              <el-option value="非语言类">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="针对语言类是否母语：">
            <el-select v-model="formCustom.zdyylsfmy" :disabled="select">
              <el-option value="是">
              </el-option>
              <el-option value="否">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="学科类/非学科类：">
            <el-select v-model="formCustom.xklfxkl" :disabled="select">
              <el-option value="学科类">
              </el-option>
              <el-option value="非学科类">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="最高学位：">
            <el-select v-model="formCustom.zgxw" :disabled="select">
              <el-option value="博士">
              </el-option>
              <el-option value="硕士">
              </el-option>
              <el-option value="学士">
              </el-option>
              <el-option value="高中">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="是否有有效职业资格证书：">
            <el-select v-model="formCustom.sfyyxzyzgzs" :disabled="select">
              <el-option value="是">
              </el-option>
              <el-option value="否">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="签证类别：">
            <el-select v-model="formCustom.qzlb" :disabled="select">
              <el-option value="Z">
              </el-option>
              <el-option value="R">
              </el-option>
              <el-option value="F">
              </el-option>
              <el-option value="M">
              </el-option>
              <el-option value="C">
              </el-option>
              <el-option value="D">
              </el-option>
              <el-option value="G">
              </el-option>
              <el-option value="J1">
              </el-option>
              <el-option value="J2">
              </el-option>
              <el-option value="L">
              </el-option>
              <el-option value="Q1">
              </el-option>
              <el-option value="Q2">
              </el-option>
              <el-option value="S1">
              </el-option>
              <el-option value="S2">
              </el-option>
              <el-option value="X1">
              </el-option>
              <el-option value="X3">
              </el-option>
              <el-option value="永久居留许可">
              </el-option>
              <el-option value="不适用">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="聘用合同类型：">
            <el-select v-model="formCustom.pyhtlx" :disabled="select">
              <el-option value="劳动">
              </el-option>
              <el-option value="劳务">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="宗教：">
            <el-select v-model="formCustom.zj" :disabled="select">
              <el-option value="未知">
              </el-option>
              <el-option value="无">
              </el-option>
              <el-option value="佛教">
              </el-option>
              <el-option value="基督教">
              </el-option>
              <el-option value="伊斯兰教">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="婚姻状况：">
            <el-select v-model="formCustom.hyzk" :disabled="select">
              <el-option value="未知">
              </el-option>
              <el-option value="未婚">
              </el-option>
              <el-option value="已婚">
              </el-option>
              <el-option value="离异">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="原单位类型：">
            <el-select v-model="formCustom.ydwlx" :disabled="select" allow-create filterable>
              <el-option value="高校">
              </el-option>
              <el-option value="中小学">
              </el-option>
              <el-option value="幼儿园">
              </el-option>
              <el-option value="培训机构">
              </el-option>
              <el-option value="无">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="工作年限：">
            <Input v-model="formCustom.gznx" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="离职日期：">
            <DatePicker :disabled="select" :value="formCustom.lzrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changelzrq"/>
          </Form-item>
          <Form-item label="在甬住址：">
            <Input v-model="formCustom.zydz" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="原单位名称：">
            <Input v-model="formCustom.ydwmc" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="毕业院校：">
            <Input v-model="formCustom.byyx" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="备注：">
            <Input v-model="formCustom.bz" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="员工状态：">
            <el-select v-model="formCustom.status" :disabled="select" allow-create filterable>
              <el-option :value="1" label="在职">
              </el-option>
              <el-option :value="0" label="待入职">
              </el-option>
              <el-option :value="2" label="离职">
              </el-option>
            </el-select>
          </Form-item>
        </Form>
        <div style="margin-bottom: 10px;">
          <span>家属信息</span>
          <Button style="margin-left: 10px;" type="primary" @click="addfamily">
            新增
          </Button>
        </div>
        <Table :columns="columns" :data="tableData" :loading="loading" aria-hidden="true" border>
          <template slot="action" slot-scope="{ row }">
            <Button size="small" type="text" @click="selectFamily(row)">查看
            </Button>
            <Button size="small" type="text" @click="putFamily(row)">编辑
            </Button>
            <Button size="small" type="text" @click="deleteFamily(row)">删除
            </Button>
            <Button size="small" type="text" @click="changeState(row)">更改状态
            </Button>
            <Button size="small" type="text" @click="showExport(row)">导出证明文件
            </Button>
          </template>
          <template slot="status" slot-scope="{ row }">
            {{
              row.status == 0 ? '服务中' : row.status == 1 ? '不在境内' : row.status == 2 ? '转化为学生签,工作签' : row.status == 3 ? '已满18周岁' : '员工离职'
            }}
          </template>
          <template slot="auditStatus" slot-scope="{ row }">
            {{ row.auditStatus == 0 ? '未确认' : '已确认' }}
          </template>
        </Table>
        <Button :loading="addloading" style="margin-left: 500px;margin-top: 10px;" type="primary" @click="add">
          确定
        </Button>
      </div>
      <div v-if="select">
        <Button style="margin-left: 900px;margin-bottom: 10px;" type="primary" @click="selectjl">
          查看历史变更记录
        </Button>
        <Form :label-width="120" :model="formCustom" inline>
          <Form-item label="员工编号：">
            <Input v-model="formCustom.zgbh" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="姓：" prop="x">
            <Input v-model="formCustom.x" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="名：" prop="m">
            <Input v-model="formCustom.m" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="姓名：" prop="xm">
            <Input v-model="formCustom.xm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="国籍：" prop="gj">
            <el-select v-model="formCustom.gj" :disabled="select" filterable>
              <el-option v-for="item in countryArr" :key="item.id" :label="item.Chinese" :value="item.Chinese">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="出生地点：">
            <Input v-model="formCustom.csdd" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="性别：" prop="xb">
            <Input v-model="formCustom.xb" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="出生年月日：" prop="csnyr">
            <DatePicker :disabled="select" :value="formCustom.csnyr" format="yyyy-MM-dd" style="width: 200px;"
                        type="date"
                        @on-change="changecsnyr"/>
          </Form-item>
          <Form-item label="类型：" prop="yglx">
            <Select v-model="formCustom.yglx" :disabled="select" style="width: 200px;">
              <Option value="员工">员工</Option>
            </Select>
          </Form-item>
          <Form-item label="学院：" prop="xy">
            <Input v-model="formCustom.xy" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="部门：" prop="bm">
            <Input v-model="formCustom.bm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="岗位名称：" prop="gwmc">
            <Input v-model="formCustom.gwmc" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="合同开始时间：">
            <DatePicker :disabled="select" :value="formCustom.htkssj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehtkssj"/>
          </Form-item>
          <Form-item label="合同结束时间：">
            <DatePicker :disabled="select" :value="formCustom.htjssj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changehtjssj"/>
          </Form-item>
          <Form-item label="薪资：">
            <Input v-model="formCustom.xz" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="护照号码：" prop="hzhm">
            <Input v-model="formCustom.hzhm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="护照签发日期：" prop="hzqfrq">
            <DatePicker v-if="formCustom.hzqfrq == '9999-01-01'" :disabled="select" :value="formCustom.hzqfrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changehzqfrq">
              <input :value="formCustom.hzqfrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.hzqfrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changehzqfrq"/>
          </Form-item>
          <Form-item label="护照到期日期：" prop="hzdqrq">
            <DatePicker v-if="formCustom.hzdqrq == '9999-01-01'" :disabled="select" :value="formCustom.hzdqrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changehzdqrq">
              <input :value="formCustom.hzdqrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.hzdqrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changehzdqrq"/>
          </Form-item>
          <p class="tips">
            当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
          <Form-item label="工作许可证编号：">
            <Input v-model="formCustom.gzxkzbh" :disabled="select" clearable
                   style="width: 200px"></Input>
          </Form-item>
          <Form-item label="工作许可证发证日期：">
            <DatePicker v-if="formCustom.gzxkzfzrq == '9999-01-01'" :disabled="select" :value="formCustom.gzxkzfzrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changegzxkzfzrq">
              <input :value="formCustom.gzxkzfzrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.gzxkzfzrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changegzxkzfzrq"/>
          </Form-item>
          <Form-item label="工作许可证到期日期：">
            <DatePicker v-if="formCustom.gzfkzdqrq == '9999-01-01'" :disabled="select" :value="formCustom.gzfkzdqrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changegzfkzdqrq">
              <input :value="formCustom.gzfkzdqrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.gzfkzdqrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changegzfkzdqrq"/>
          </Form-item>
          <p class="tips">
            当到期日期为空时，表示需要办理但还未办理下来，会进行待办提醒，当到期日期为9999-01-01时，表示不需要办理，不会提醒</p>
          <Form-item label="居留许可证编号：">
            <Input v-model="formCustom.jlxkzbh" :disabled="select" clearable
                   style="width: 200px"></Input>
          </Form-item>
          <Form-item label="居留许可证签发日期：">
            <DatePicker v-if="formCustom.jlxkzqfrq == '9999-01-01'" :disabled="select" :value="formCustom.jlxkzqfrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changejlxkzqfrq">
              <input :value="formCustom.jlxkzqfrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.jlxkzqfrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changejlxkzqfrq"/>
          </Form-item>
          <Form-item label="居留许可证到期日期：">
            <DatePicker v-if="formCustom.jlxkzdqrq == '9999-01-01'" :disabled="select" :value="formCustom.jlxkzdqrq"
                        format="yyyy-MM-dd" style="width: 200px;" type="date" @on-change="changejlxkzdqrq">
              <input :value="formCustom.jlxkzdqrq" disabled style="color: rgb(216, 9, 9);width: 100%;height: 32px;
              padding: 4px 7px;border-radius: 4px;font-size: 12px !important;" type="text"/>
            </DatePicker>
            <DatePicker v-else :disabled="select" :value="formCustom.jlxkzdqrq" format="yyyy-MM-dd"
                        style="width: 200px;" type="date" @on-change="changejlxkzdqrq"/>
          </Form-item>
          <Form-item label="保单到期时间：">
            <DatePicker :disabled="select" :value="formCustom.bddqsj" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changebddqsj"/>
          </Form-item>
          <Form-item label="HR负责人：" prop="hrfzr">
            <Input v-model="formCustom.hrfzr" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="工作证类别：" prop="gzzlb">
            <el-select v-model="formCustom.gzzlb" :disabled="select">
              <el-option value="A">
              </el-option>
              <el-option value="B">
              </el-option>
              <el-option value="A-PR">
              </el-option>
              <el-option value="B-PR">
              </el-option>
              <el-option value="C">
              </el-option>
              <el-option value="无WPC">
              </el-option>
              <el-option value="WPC过期">
              </el-option>
              <el-option value="无WPC-PR">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="外专局账户：">
            <el-select v-model="formCustom.wzjzh" :disabled="select">
              <el-option value="UNNC">
              </el-option>
              <el-option value="CIIC">
              </el-option>
              <el-option value="/">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="手机号码：">
            <Input v-model="formCustom.sjhm" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="全职-兼职：">
            <el-select v-model="formCustom.gzxz" :disabled="select">
              <el-option value="全职">
              </el-option>
              <el-option value="兼职">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="境内/境外：">
            <el-select v-model="formCustom.gjlx" :disabled="select">
              <el-option value="境内">
              </el-option>
              <el-option value="境外">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="岗位类别：">
            <el-select v-model="formCustom.gwlb" :disabled="select">
              <el-option value="教学">
              </el-option>
              <el-option value="科研">
              </el-option>
              <el-option value="管理">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="专业科目：">
            <el-select v-model="formCustom.zykm" :disabled="select">
              <el-option label="哲学" value="哲学">
              </el-option>
              <el-option value="经济学">
              </el-option>
              <el-option value="法学">
              </el-option>
              <el-option value="教育学">
              </el-option>
              <el-option value="文学">
              </el-option>
              <el-option value="理学">
              </el-option>
              <el-option value="工学">
              </el-option>
              <el-option value="农学">
              </el-option>
              <el-option value="管理学">
              </el-option>
              <el-option value="艺术学">
              </el-option>
              <el-option value="外国语言教育">
              </el-option>
              <el-option value="西班牙语">
              </el-option>
              <el-option value="英语">
              </el-option>
              <el-option value="法语">
              </el-option>
              <el-option value="德语">
              </el-option>
              <el-option value="俄语">
              </el-option>
              <el-option value="意大利语">
              </el-option>
              <el-option value="葡萄牙语">
              </el-option>
              <el-option value="日语">
              </el-option>
              <el-option value="韩语">
              </el-option>
              <el-option value="阿拉伯语">
              </el-option>
              <el-option value="其它">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="语言类/非语言类：">
            <el-select v-model="formCustom.yylfyyl" :disabled="select">
              <el-option value="语言类">
              </el-option>
              <el-option value="非语言类">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="针对语言类是否母语：">
            <el-select v-model="formCustom.zdyylsfmy" :disabled="select">
              <el-option value="是">
              </el-option>
              <el-option value="否">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="学科类/非学科类：">
            <el-select v-model="formCustom.xklfxkl" :disabled="select">
              <el-option value="学科类">
              </el-option>
              <el-option value="非学科类">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="最高学位：">
            <el-select v-model="formCustom.zgxw" :disabled="select">
              <el-option value="博士">
              </el-option>
              <el-option value="硕士">
              </el-option>
              <el-option value="学士">
              </el-option>
              <el-option value="高中">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="是否有有效职业资格证书：">
            <el-select v-model="formCustom.sfyyxzyzgzs" :disabled="select">
              <el-option value="是">
              </el-option>
              <el-option value="否">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="签证类别：">
            <el-select v-model="formCustom.qzlb" :disabled="select">
              <el-option value="Z">
              </el-option>
              <el-option value="R">
              </el-option>
              <el-option value="F">
              </el-option>
              <el-option value="M">
              </el-option>
               
              <el-option value="C">
              </el-option>
              <el-option value="D">
              </el-option>
              <el-option value="G">
              </el-option>
              <el-option value="J1">
              </el-option>
              <el-option value="J2">
              </el-option>
              <el-option value="L">
              </el-option>
              <el-option value="Q1">
              </el-option>
              <el-option value="Q2">
              </el-option>
              <el-option value="S1">
              </el-option>
              <el-option value="S2">
              </el-option>
              <el-option value="X1">
              </el-option>
              <el-option value="X3">
              </el-option>
              <el-option value="永久居留许可">
              </el-option>
              <el-option value="不适用">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="聘用合同类型：">
            <el-select v-model="formCustom.pyhtlx" :disabled="select">
              <el-option value="劳动">
              </el-option>
              <el-option value="劳务">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="宗教：">
            <el-select v-model="formCustom.zj" :disabled="select">
              <el-option value="未知">
              </el-option>
              <el-option value="无">
              </el-option>
              <el-option value="佛教">
              </el-option>
              <el-option value="基督教">
              </el-option>
              <el-option value="伊斯兰教">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="婚姻状况：">
            <el-select v-model="formCustom.hyzk" :disabled="select">
              <el-option value="未知">
              </el-option>
              <el-option value="未婚">
              </el-option>
              <el-option value="已婚">
              </el-option>
              <el-option value="离异">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="原单位类型：">
            <el-select v-model="formCustom.ydwlx" :disabled="select" allow-create filterable>
              <el-option value="高校">
              </el-option>
              <el-option value="中小学">
              </el-option>
              <el-option value="幼儿园">
              </el-option>
              <el-option value="培训机构">
              </el-option>
              <el-option value="无">
              </el-option>
            </el-select>
          </Form-item>
          <Form-item label="工作年限：">
            <Input v-model="formCustom.gznx" :disabled="select" clearable style="width: 200px"></Input>
          </Form-item>
          <Form-item label="离职日期：">
            <DatePicker :disabled="select" :value="formCustom.lzrq" format="yyyy-MM-dd" style="width: 200px;"
                        type="date" @on-change="changelzrq"/>
          </Form-item>
          <Form-item label="在甬住址：">
            <Input v-model="formCustom.zydz" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="原单位名称：">
            <Input v-model="formCustom.ydwmc" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="毕业院校：">
            <Input v-model="formCustom.byyx" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
          <Form-item label="备注：">
            <Input v-model="formCustom.bz" :disabled="select" clearable style="width: 400px"></Input>
          </Form-item>
        </Form>
        <Table :columns="columnsselect" :data="tableData" :loading="loading" aria-hidden="true" border>
          <template slot="auditStatus" slot-scope="{ row }">
            {{ row.auditStatus == 0 ? '未确认' : '已确认' }}
          </template>
          <template slot="status" slot-scope="{ row }">
            {{
              row.status == 0 ? '服务中' : row.status == 1 ? '不在境内' : row.status == 2 ? '转化为学生签,工作签' : row.status == 3 ? '已满18周岁' : '员工离职'
            }}
          </template>
        </Table>
      </div>
    </el-dialog>
    <addfamily :isupload="isuploadFalily" :model="addrowFalily" :select="selectFalily" :visible="visibleFalily"
               @cancel="handleCancelFalily" @successadd="successadd"/>
    <export-record
      :isupload="isuploadExportRecord"
      :model="addrowExportRecord"
      :select="selectExportRecord"
      :visible="visibleExportRecord"
      @cancel="handleCancelExportRecord"
    />
    <exportfile
      :model="addrowExportfile"
      :visible="visibleExportfile"
      @cancel="handleCancelExportfile"
    />
    <el-dialog :visible.sync="dialogVisible" title="更改家属状态" width="500px">
      <Form ref="searchForm" :label-width="90" :model="formCustomchange">
        <Form-item label="选择状态：">
          <Select v-model="formCustomchange.status" clearable filterable style="width: 200px">
            <Option :value="0">服务中</Option>
            <Option :value="1">不在境内</Option>
            <Option :value="2">转化为学生签,工作签</Option>
            <Option :value="3">已满18周岁</Option>
            <Option :value="4">员工离职</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="put">确认</Button>
        </Form-item>
      </Form>
    </el-dialog>
  </div>
</template>
<script>
import permissionList from "@/libs/handlePermission.ts";
import exportfile from "@/views/employee/exportFileEmployee.vue"
import exportRecord from "./exportRecord.vue"
import addfamily from "./addfamily.vue"
import {
  employeeAdd,
  employeeDetail,
  employeeEntryt,
  employeeFamilyMemberDelete,
  employeeFamilyMemberPage,
  employeeFamilyMemberUpdateStatus,
  employeePut
} from '@/api/employee'

import {countryArr} from "./country";

export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      default: () => null
    },
    isupload: {
      type: Boolean,
      required: false
    },
    select: {
      type: Boolean,
      required: false
    },
    isentry: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    visible(v) {
      console.log(v)
      this.visible_v = v
      if (v) {
        this.init()
      }
    }
  },
  name: "company",
  data() {
    const validatecsnyr = (rule, value, callback) => {
      if (!this.formCustom.csnyr) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    const validatehzqfrq = (rule, value, callback) => {
      if (!this.formCustom.hzqfrq) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    const validatehzdqrq = (rule, value, callback) => {
      if (!this.formCustom.hzdqrq) {
        callback(new Error('请选择'));
      } else {
        callback();
      }
    }
    return {
      visibleExportfile: false,
      addrowExportfile: false,
      dialogVisible: false,
      formCustomchange: {},
      isuploadExportRecord: false,
      addrowExportRecord: {},
      selectExportRecord: false,
      visibleExportRecord: false,
      isuploadFalily: false,
      addrowFalily: {},
      selectFalily: false,
      visibleFalily: false,
      activeName: 'zz',
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "家属姓名", key: "xm", align: "center"},
        {title: "国籍", key: "gj", align: "center"},
        {title: "家属类型", key: "jslx", align: "center"},
        {title: "出生年月日", key: "csnyr", align: "center"},
        {title: "护照号码", key: "hzhm", align: "center"},
        {title: "护照到期日期", key: "hzdqrq", align: "center"},
        {title: "居留许可号码", key: "jlxkzbh", align: "center"},
        {title: "居留许可签发日期", key: "jlxkzqfrq", align: "center"},
        {title: "居留许可到期日期", align: "jlxkzdqrq", key: "jlxkzdqrq", fixed: "right"},
        {title: "状态", key: "status", slot: "status", align: "center"},
        {title: "复核状态", key: "auditStatus", slot: "auditStatus", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right", width: 120},
      ],
      columnsselect: [
        {type: "index", title: "序号", align: "center"},
        {title: "家属姓名", key: "xm", align: "center"},
        {title: "国籍", key: "gj", align: "center"},
        {title: "家属类型", key: "jslx", align: "center"},
        {title: "出生年月日", key: "csnyr", align: "center"},
        {title: "护照号码", key: "hzhm", align: "center"},
        {title: "护照到期日期", key: "hzdqrq", align: "center"},
        {title: "居留许可号码", key: "jlxkzbh", align: "center"},
        {title: "居留许可签发日期", key: "jlxkzqfrq", align: "center"},
        {title: "居留许可到期日期", key: "jlxkzdqrq", align: "center", fixed: "right"},
        {title: "状态", key: "status", slot: "status", align: "center"},
        {title: "复核状态", key: "auditStatus", slot: "auditStatus", align: "center"},
      ],
      tableData: [],
      loading: false,
      countryArr: countryArr,
      addloading: false,
      defaultValue: [],
      isShow: false,
      organization: '',
      formCustom: {},
      visible_v: false,
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      value: 1,
      options: [],
      organizationList: [], // 组织机构列表
      ruleValidateD: {
        xm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gj: [
          {required: true, message: '请选择', trigger: 'blur'}
        ],
        yglx: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        bm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gwmc: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        hzhm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        hrfzr: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        xy: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
      },
      ruleValidate: {
        xm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gj: [
          {required: true, message: '请选择', trigger: 'blur'}
        ],
        xb: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        csnyr: [
          {required: true, validator: validatecsnyr, trigger: 'blur'}
        ],
        yglx: [
          {required: true, message: '请选择', trigger: 'blur'}
        ],
        xy: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        bm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gwmc: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        hzhm: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        hzqfrq: [
          {required: true, validator: validatehzqfrq, trigger: 'blur'}
        ],
        hzdqrq: [
          {required: true, validator: validatehzdqrq, trigger: 'blur'}
        ],
        hrfzr: [
          {required: true, message: '请填写', trigger: 'blur'}
        ],
        gzzlb: [
          {required: true, message: '请选择', trigger: 'blur'}
        ],
      },
      employeeChangeLogId: ''
    }
  },
  components: {
    addfamily,
    exportfile,
    exportRecord
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.init()
    this.roleType = user.roleType;
  },
  methods: {
    handleCancelExportRecord(v) {
      console.log(v)
      if (v) {
        console.log(v)
        this.$emit('put', v)
      } else {
        this.employeeChangeLogId = ''
      }
      this.visibleExportRecord = false
    },
    handleChange(date) {
      this.formCustom.csnyr = date
      console.log(date)
    },
    init() {
      console.log(this.model)
      if (this.model.employeeId) {
        employeeDetail({employeeId: this.model.employeeId}).then((res) => {
          this.formCustom = res.data.data
        });
      } else {
        this.formCustom = {}
      }
      employeeFamilyMemberPage({employeeId: this.model.employeeId, current: 1, size: 99}).then((res) => {
        this.tableData = res.data.data.records;
        this.loading = false;
      });
    },
    addD() {
      if (this.formCustom.gj != '中国') {
        this.$refs['addDEmployess'].validate((valid) => {
          if (valid) {
            this.addloading = true
            if (this.formCustom.csnyr) this.formCustom.csnyr = this.$moment(this.formCustom.csnyr).format("YYYY-MM-DD")
            // this.formCustom.hzdqrq = this.$moment(this.formCustom.hzdqrq).format("YYYY-MM-DD")
            if (this.formCustom.hzqfrq) this.formCustom.hzqfrq = this.$moment(this.formCustom.hzqfrq).format("YYYY-MM-DD")
            this.formCustom.status = 0
            employeeAdd(this.formCustom).then(res => {
              this.addloading = false
              if (res.data.success) {
                this.$emit('successadd')
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(error => {
              this.addloading = false
              this.$message.error(error.response.data.msg);
            })
          }
        })
      } else if (this.formCustom.x && this.formCustom.m && this.formCustom.xm) {
        this.formCustom.status = 0
        employeeAdd(this.formCustom).then(res => {
          this.addloading = false
          if (res.data.success) {
            this.$emit('successadd')
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(error => {
          this.addloading = false
          this.$message.error(error.response.data.msg);
        })
      } else {
        this.$message.error('请填写姓，名，姓名');
      }
    },
    add() {
      if (this.formCustom.gj != '中国') {
        if (this.isupload) {
          this.$refs['putEmployess'].validate((valid) => {
            if (valid) {
              this.addloading = true
              this.formCustom.csnyr = this.$moment(this.formCustom.csnyr).format("YYYY-MM-DD")
              this.formCustom.hzdqrq = this.$moment(this.formCustom.hzdqrq).format("YYYY-MM-DD")
              this.formCustom.hzqfrq = this.$moment(this.formCustom.hzqfrq).format("YYYY-MM-DD")
              let params = {...this.formCustom, employeeId: this.model.employeeId};
              if (this.model.employeeChangeLogId) params.employeeChangeLogId = this.model.employeeChangeLogId
              employeePut(params).then(res => {
                this.addloading = false
                if (res.data.success) {
                  this.$emit('successadd')
                  this.$message.success('编辑成功');
                } else {
                  this.$message.error(res.data.msg);
                }
                if (this.isentry) {
                  employeeEntryt({employeeId: this.model.employeeId}).then((res) => {
                    if (res.data.success === false) {
                      this.$message.warning(res.data.msg)
                    } else {
                      this.$message.success('入职成功')
                      this.$emit('successadd')
                    }
                  }).catch((error) => {
                    this.$message.error(error.response.data.msg)
                  })
                }
              }).catch(error => {
                this.addloading = false
                this.$message.error(error.response.data.msg);
              })
            }
          })
        } else {
          this.$refs['addEmployess'].validate((valid) => {
            if (valid) {
              this.addloading = true
              this.formCustom.status = 1
              this.formCustom.csnyr = this.$moment(this.formCustom.csnyr).format("YYYY-MM-DD")
              // this.formCustom.hzdqrq = this.$moment(this.formCustom.hzdqrq).format("YYYY-MM-DD")
              this.formCustom.hzqfrq = this.$moment(this.formCustom.hzqfrq).format("YYYY-MM-DD")
              employeeAdd(this.formCustom).then(res => {
                this.addloading = false
                if (res.data.success) {
                  this.$emit('successadd')
                  this.$message.success(res.data.msg);
                } else {
                  this.$message.error(res.data.msg);
                }
              }).catch(error => {
                this.addloading = false
                this.$message.error(error.response.data.msg);
              })
            }
          })
        }
      } else {
        console.log(123)
        this.addloading = true
        if (this.isupload) {
          let params = {...this.formCustom, employeeId: this.model.employeeId}
          if (this.model.employeeChangeLogId) params.employeeChangeLogId = this.model.employeeChangeLogId
          employeePut(params).then(res => {
            this.addloading = false
            if (res.data.success) {
              this.$emit('successadd')
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.addloading = false
            this.$message.error(error.response.data.msg);
          })
        } else {
          this.formCustom.status = 1
          employeeAdd(this.formCustom).then(res => {
            this.addloading = false
            if (res.data.success) {
              this.$emit('successadd')
              this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(error => {
            this.addloading = false
            this.$message.error(error.response.data.msg);
          })
        }
      }
    },
    addfamily() {
      this.visibleFalily = true
      this.selectFalily = false
      this.isuploadFalily = false
      this.addrowFalily = {employeeId: this.model.employeeId}
    },
    handleCancelFalily() {
      this.visibleFalily = false
    },
    successadd() {
      this.init()
      this.visibleFalily = false
    },
    putFamily(row) {
      this.visibleFalily = true
      this.selectFalily = false
      this.isuploadFalily = true
      this.addrowFalily = row
    },
    selectFamily(row) {
      this.visibleFalily = true
      this.selectFalily = true
      this.isuploadFalily = false
      this.addrowFalily = row
    },
    changeState(row) {
      this.dialogVisible = true
      this.row = row
      this.formCustomchange = {}
    },
    deleteFamily(row) {
      this.$confirmss('是否确认删除该家属', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        employeeFamilyMemberDelete({
          employeeFamilyMemberId: row.employeeFamilyMemberId
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.init();
          }
        })
      }).catch(() => {
      })
    },
    changecsnyr(t) {
      this.formCustom.csnyr = t
    },
    changehtkssj(t) {
      this.formCustom.htkssj = t
    },
    changehzqfrq(t) {
      this.formCustom.hzqfrq = t
    },
    changehzdqrq(t) {
      console.log(t)
      // this.formCustom.hzdqrq = this.$moment(t).format()
      this.formCustom.hzdqrq = t
    },
    changegzxkzfzrq(t) {
      this.formCustom.gzxkzfzrq = t
    },
    changegzfkzdqrq(t) {
      this.formCustom.gzfkzdqrq = t
    },
    changejlxkzqfrq(t) {
      this.formCustom.jlxkzqfrq = t
    },
    changejlxkzdqrq(t) {
      this.formCustom.jlxkzdqrq = t
    },
    changebddqsj(t) {
      this.formCustom.bddqsj = t
    },
    changelzrq(t) {
      this.formCustom.lzrq = t
    },
    changehtjssj(t) {
      this.formCustom.htjssj = t
    },
    selectjl() {
      this.visibleExportRecord = true
      this.selectExportRecord = true
      this.addrowExportRecord = this.model
    },
    put() {
      employeeFamilyMemberUpdateStatus({
        employeeFamilyMemberId: this.row.employeeFamilyMemberId,
        status: this.formCustomchange.status,
      }).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogVisible = false
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((error) => {
        this.$message.error(error.response.data.msg)
      })
    },
    showExport(row) {
      this.visibleExportfile = true
      this.addrowExportfile = row
    },
    handleCancelExportfile() {
      this.visibleExportfile = false
    },
  }
}
</script>
<style>
input:disabled {
  border: 1px solid #DDD;
  background-color: #F5F5F5;
  color: #e9bb13;
  opacity: 1;
}

.tips {
  color: #ff0000;
  width: 410px;
  margin-left: 650px;
}
</style>
